import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 680.000000 564.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,564.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M4285 4370 c3 -5 13 -10 21 -10 8 0 14 -4 14 -8 0 -5 21 -18 48 -30
26 -12 74 -38 107 -58 97 -58 227 -126 232 -121 4 5 -44 33 -304 175 -114 63
-129 70 -118 52z"
          />
          <path d="M4797 4089 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path
            d="M4830 4072 c0 -9 140 -85 147 -79 2 3 -15 16 -39 29 -72 42 -108 59
-108 50z"
          />
          <path
            d="M5030 3960 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"
          />
          <path
            d="M5080 3930 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"
          />
          <path d="M5157 3889 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path
            d="M5220 3858 c21 -19 70 -48 70 -40 0 5 -12 15 -27 23 -36 17 -49 23
-43 17z"
          />
          <path
            d="M5370 3770 c8 -6 43 -27 78 -47 35 -19 66 -42 69 -49 2 -7 11 -10 19
-7 15 6 19 23 5 23 -5 0 -44 20 -87 45 -44 25 -83 45 -89 45 -5 0 -3 -5 5 -10z"
          />
          <path
            d="M3110 3685 c0 -2 14 -11 30 -20 17 -9 30 -12 30 -7 0 5 -11 14 -25
20 -28 13 -35 14 -35 7z"
          />
          <path
            d="M3185 3640 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path
            d="M3225 3620 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path d="M3397 3529 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path d="M3437 3509 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path
            d="M2960 3483 c0 -5 6 -15 13 -23 11 -14 20 -18 52 -24 13 -3 118 -56
170 -86 45 -27 223 -122 395 -212 63 -33 120 -64 125 -68 6 -4 53 -29 105 -55
52 -27 106 -56 120 -66 14 -9 89 -49 168 -89 l142 -72 -6 -219 c-5 -160 -4
-219 5 -219 6 0 143 64 303 141 582 281 825 397 909 437 l86 40 6 93 c7 96 10
359 4 359 -2 0 -69 -31 -148 -69 -79 -38 -184 -88 -234 -111 -278 -132 -490
-233 -728 -349 l-188 -91 -42 24 c-23 13 -87 47 -142 76 -98 51 -320 170 -660
355 -93 51 -199 107 -235 125 -36 18 -95 50 -132 71 -65 38 -88 46 -88 32z"
          />
          <path
            d="M3700 3366 c0 -2 17 -14 38 -25 l37 -21 -30 25 c-28 23 -45 31 -45
21z"
          />
          <path
            d="M3790 3310 c20 -13 33 -13 25 0 -3 6 -14 10 -23 10 -15 0 -15 -2 -2
-10z"
          />
          <path d="M3860 3276 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
          <path
            d="M2950 2832 c0 -11 14 -21 42 -30 23 -7 60 -26 83 -40 22 -15 69 -40
105 -56 35 -16 86 -42 113 -58 26 -15 50 -28 53 -28 2 0 21 -10 42 -23 20 -13
118 -65 217 -117 99 -51 185 -96 190 -100 6 -5 66 -38 135 -73 69 -36 166 -87
215 -114 l90 -48 0 -62 c-2 -283 -6 -363 -17 -363 -7 0 -49 19 -93 42 -44 23
-111 57 -150 76 -38 19 -81 42 -95 52 -14 9 -90 51 -170 92 -261 136 -345 182
-348 190 -2 4 -8 8 -13 8 -11 0 -66 26 -119 57 -20 11 -69 37 -110 58 -41 21
-89 49 -107 62 -36 26 -65 29 -82 9 -14 -17 -20 -13 119 -84 222 -114 435
-225 445 -232 6 -4 91 -49 190 -100 99 -51 239 -125 310 -163 103 -55 141 -70
185 -74 59 -5 51 -9 440 180 611 296 794 383 850 403 l65 23 8 58 c4 32 6 137
5 234 l-3 175 -175 -84 c-96 -47 -312 -151 -480 -232 -168 -81 -381 -184 -474
-229 l-168 -81 -132 69 c-72 39 -151 80 -176 93 -25 13 -47 25 -50 28 -3 3
-28 17 -55 31 -28 14 -120 63 -205 109 -85 45 -202 108 -260 138 -58 31 -122
66 -142 79 -21 13 -40 23 -42 23 -3 0 -55 27 -116 60 -61 33 -113 60 -116 60
-2 0 -4 -8 -4 -18z"
          />
          <path
            d="M2500 2415 c47 -18 74 -18 31 0 -18 8 -41 15 -50 14 -9 0 0 -7 19
-14z"
          />
          <path
            d="M317 2153 c-3 -4 -7 -89 -9 -188 l-3 -180 262 -10 c144 -5 265 -13
269 -17 11 -11 -13 -867 -25 -909 -34 -114 -121 -168 -239 -149 -75 13 -134
43 -202 106 -81 76 -91 74 -170 -38 -99 -139 -144 -220 -133 -238 6 -8 46 -43
91 -76 l81 -62 -31 -6 c-17 -3 -43 -6 -59 -6 -29 0 -29 -1 -29 -59 0 -41 4
-60 14 -64 20 -8 1300 -21 1330 -13 24 6 26 10 26 66 0 45 -4 61 -17 68 -10 6
-103 8 -225 4 -114 -3 -208 -2 -208 2 0 4 24 30 54 57 119 109 174 248 190
481 l6 77 -128 3 -127 3 -3 27 c-3 27 -3 27 65 30 l68 3 6 150 c4 83 7 296 9
475 1 179 5 349 8 378 l5 52 58 0 c33 0 59 4 59 9 0 12 -177 19 -626 27 -199
3 -364 2 -367 -3z"
          />
          <path
            d="M2120 2120 c0 -5 11 -12 25 -16 l25 -6 0 -208 c0 -115 -4 -211 -9
-214 -5 -3 -21 -32 -37 -63 l-28 -58 -4 -269 c-3 -199 -1 -275 8 -292 21 -39
7 -54 -52 -55 -89 -2 -112 -10 -115 -41 -4 -60 -40 -57 683 -64 646 -7 662 -7
666 12 2 10 2 31 0 47 -4 25 -7 27 -54 27 l-50 0 7 235 7 235 -37 0 c-27 0
-48 9 -79 35 -23 19 -65 44 -92 56 -44 20 -47 23 -29 33 45 25 121 112 133
152 29 98 8 235 -48 313 -64 88 -164 128 -355 142 -167 12 -565 12 -565 -1z
m594 -283 c38 -25 49 -53 44 -114 -8 -88 -23 -97 -173 -101 l-125 -4 0 114 c0
63 4 118 9 124 16 15 215 0 245 -19z m1 -478 c67 -13 92 -34 107 -92 11 -43
11 -52 -7 -85 -33 -61 -77 -76 -232 -80 l-133 -4 0 134 c0 74 3 137 6 141 8 8
196 -2 259 -14z m395 -409 c0 -11 -7 -20 -15 -20 -13 0 -13 3 -3 20 7 11 14
20 15 20 2 0 3 -9 3 -20z"
          />
          <path
            d="M1937 1898 c-16 -28 -16 -33 -2 -47 10 -10 15 -11 15 -3 0 7 -5 12
-10 12 -6 0 -3 11 6 25 9 13 14 29 12 34 -1 6 -11 -4 -21 -21z"
          />
          <path d="M1911 1834 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M1860 1731 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path
            d="M1430 1624 c0 -39 17 -82 95 -246 52 -109 95 -201 95 -205 0 -15 56
-93 68 -93 6 0 12 1 12 3 0 9 -58 146 -122 287 -101 227 -132 291 -140 296 -5
3 -8 -16 -8 -42z"
          />
          <path
            d="M1798 1599 c-21 -35 -24 -47 -15 -66 6 -13 13 -21 16 -18 14 15 37
93 31 110 -5 15 -11 10 -32 -26z"
          />
          <path
            d="M4160 1325 c0 -41 2 -45 25 -45 23 0 25 4 25 45 0 41 -2 45 -25 45
-23 0 -25 -4 -25 -45z"
          />
          <path
            d="M4725 1283 c-99 -206 -185 -397 -185 -413 0 -6 16 -10 36 -10 19 0
33 4 30 8 -2 4 2 21 9 37 8 17 28 65 44 107 17 42 39 94 51 115 11 21 20 41
20 45 0 5 14 37 31 73 40 86 45 115 20 115 -14 0 -29 -21 -56 -77z m55 53 c0
-3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z"
          />
          <path
            d="M5640 1337 c0 -10 -8 -17 -19 -17 -17 0 -20 -10 -26 -76 -10 -107 -1
-253 18 -289 25 -49 70 -85 113 -91 l39 -5 -27 16 c-16 8 -38 35 -50 58 -20
38 -23 61 -28 224 -3 100 -8 185 -12 189 -5 4 -8 0 -8 -9z"
          />
          <path
            d="M5920 1340 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
          />
          <path
            d="M6136 1324 c-3 -8 -9 -118 -12 -243 l-7 -228 31 -5 c18 -2 33 0 36 7
7 18 7 450 0 468 -8 21 -40 22 -48 1z"
          />
          <path
            d="M3840 1313 c0 -7 -18 -50 -39 -95 -132 -278 -159 -343 -144 -351 29
-17 46 0 80 83 19 47 51 123 70 170 19 46 41 93 49 104 8 11 14 32 14 46 0 14
5 31 12 38 8 8 9 12 1 12 -6 0 -14 -6 -16 -12 -4 -10 -8 -9 -16 2 -7 10 -11
11 -11 3z"
          />
          <path
            d="M5915 1161 c-6 -136 -10 -165 -26 -185 -24 -31 -24 -35 1 -29 11 3
20 10 20 15 0 5 4 7 8 4 11 -6 25 4 45 34 14 20 17 49 16 175 0 82 -4 141 -8
130 -8 -19 -8 -19 -19 0 -8 15 -12 16 -12 5 0 -12 -2 -13 -9 -1 -5 8 -12 -50
-16 -148z m22 67 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z"
          />
          <path
            d="M3464 1240 c29 -35 41 -84 33 -142 -7 -51 -33 -88 -78 -110 l-34 -18
30 0 c41 1 111 34 125 59 18 35 23 113 8 156 -8 25 -26 48 -47 62 -50 34 -69
30 -37 -7z"
          />
          <path
            d="M4305 1158 c-3 -62 -5 -151 -3 -198 3 -83 4 -85 29 -88 24 -3 27 1
33 44 3 26 6 116 6 200 l0 154 -29 0 -29 0 -7 -112z"
          />
          <path
            d="M5455 1245 c22 -8 47 -14 55 -14 21 1 -51 27 -75 28 -11 0 -2 -6 20
-14z"
          />
          <path
            d="M5140 1230 c-4 -37 1 -83 11 -102 11 -20 45 -36 152 -74 83 -29 102
-47 91 -90 -6 -23 -4 -26 15 -20 11 3 30 8 40 11 22 7 33 28 25 50 -6 15 -39
28 -160 65 -63 19 -74 26 -93 60 -11 21 -21 48 -21 61 0 30 -19 60 -27 42 -7
-18 -21 -16 -26 5 -3 12 -5 10 -7 -8z"
          />
          <path
            d="M6399 1227 c10 -27 4 -67 -10 -67 -5 0 -9 -4 -9 -10 0 -13 56 -13 81
0 22 12 26 62 7 78 -7 5 -28 13 -46 17 -31 6 -32 6 -23 -18z"
          />
          <path
            d="M3956 1214 c-4 -15 0 -46 9 -75 9 -27 14 -53 10 -59 -4 -6 8 -10 29
-10 43 0 44 4 7 94 -31 77 -45 90 -55 50z"
          />
          <path
            d="M4849 1199 c-8 -16 -8 -36 2 -80 13 -58 14 -59 47 -59 30 0 33 2 27
23 -16 54 -51 137 -57 137 -4 0 -12 -10 -19 -21z"
          />
          <path
            d="M6415 1034 c10 -24 11 -54 1 -76 -7 -15 -3 -18 24 -18 44 0 70 16 70
44 0 29 -27 54 -70 62 -30 7 -33 5 -25 -12z"
          />
          <path
            d="M4046 933 c9 -21 18 -44 21 -50 3 -7 9 -13 13 -13 5 0 16 -3 26 -7
14 -5 16 -3 10 13 -4 10 -9 27 -11 36 -8 36 -26 58 -50 58 l-25 0 16 -37z"
          />
          <path
            d="M4920 950 c0 -27 31 -81 52 -89 35 -13 38 -5 18 46 -14 38 -23 49
-44 51 -14 2 -26 -2 -26 -8z"
          />
          <path
            d="M5137 923 c-18 -17 3 -34 58 -47 30 -7 30 -7 8 9 -13 9 -23 24 -23
33 0 15 -2 15 -10 2 -8 -12 -12 -12 -18 -2 -5 7 -11 9 -15 5z"
          />
          <path
            d="M1533 690 c-18 -7 -23 -17 -23 -45 0 -32 4 -38 35 -51 30 -12 40 -12
63 -2 30 15 43 67 20 85 -20 16 -70 23 -95 13z"
          />
          <path
            d="M2216 619 c-3 -34 -6 -133 -6 -219 l0 -158 30 -11 c17 -5 57 -13 90
-17 52 -6 66 -3 113 19 35 18 59 38 73 62 l20 35 25 -37 c39 -60 80 -78 180
-78 91 0 119 11 119 46 0 22 15 25 23 5 3 -8 21 -23 39 -32 40 -21 211 -25
231 -5 8 8 12 50 12 122 0 104 1 110 20 107 18 -3 21 -13 25 -95 4 -69 9 -96
23 -111 38 -42 157 -53 187 -17 10 13 16 12 44 -3 23 -13 53 -17 123 -16 51 1
99 6 105 12 9 7 29 6 68 -4 30 -8 70 -14 88 -14 49 0 103 29 116 62 13 34 20
35 34 3 19 -40 67 -59 157 -59 44 0 92 5 108 12 l28 12 -3 147 -3 148 -61 3
-61 3 -5 -111 c-3 -63 -9 -115 -16 -122 -18 -18 -24 12 -26 120 0 53 -5 100
-11 104 -15 11 -123 10 -127 -2 -2 -6 -23 -4 -53 6 -108 33 -197 2 -211 -73
-10 -51 7 -77 70 -106 31 -15 56 -31 56 -37 0 -15 -50 -24 -63 -11 -22 22 -56
13 -64 -16 -6 -20 -10 5 -13 79 -4 95 -8 109 -29 132 -30 32 -113 50 -182 41
-57 -8 -67 -21 -47 -62 13 -26 17 -28 66 -25 33 3 52 0 52 -7 0 -6 -11 -11
-25 -11 -38 0 -102 -29 -118 -54 -9 -12 -17 -33 -19 -47 -2 -18 -10 -25 -30
-27 l-28 -3 0 75 0 76 29 0 c36 0 43 9 35 48 -5 24 -12 32 -33 34 -23 3 -26 8
-29 46 -2 24 -8 42 -15 42 -7 0 -21 3 -33 6 -17 5 -30 -7 -70 -62 -27 -37 -52
-73 -57 -78 -5 -7 -12 -5 -21 6 -31 42 -164 63 -230 38 -25 -9 -26 -11 -13
-42 12 -30 17 -33 61 -34 77 -2 74 -15 -8 -29 -25 -4 -50 -17 -68 -37 l-28
-30 0 156 0 156 -60 0 -59 0 -7 -59 c-7 -61 -15 -70 -67 -71 -34 0 -82 -30
-106 -65 l-23 -35 -22 32 c-28 42 -76 69 -128 73 l-43 3 -3 61 -3 61 -58 0
-58 0 -7 -61z m1759 -248 c-5 -13 -7 -13 -15 -1 -5 8 -31 26 -57 40 -26 14
-46 30 -45 35 1 6 23 10 49 10 42 0 47 3 57 30 10 28 11 25 14 -34 2 -35 0
-71 -3 -80z m-1577 36 c3 -52 -17 -97 -43 -97 -19 0 -21 120 -3 138 25 25 43
9 46 -41z m332 -6 c0 -69 -6 -91 -26 -91 -33 0 -41 101 -11 136 26 29 37 15
37 -45z m298 -73 c-4 -27 -28 -36 -28 -10 0 20 8 32 22 32 5 0 8 -10 6 -22z
m523 -21 c-8 -8 -11 -5 -11 9 0 27 14 41 18 19 2 -9 -1 -22 -7 -28z"
          />
          <path
            d="M4326 662 c-9 -14 -20 -375 -13 -404 6 -22 15 -26 82 -38 91 -16 136
-9 182 26 42 32 63 78 63 139 0 85 -46 139 -132 156 l-58 12 0 49 c0 30 -5 50
-12 53 -34 10 -107 15 -112 7z m164 -263 c0 -51 -13 -89 -30 -89 -11 0 -14
123 -3 133 3 4 12 7 20 7 9 0 13 -15 13 -51z"
          />
          <path
            d="M1487 553 c-4 -3 -7 -23 -7 -44 0 -29 4 -38 21 -42 20 -5 20 -10 14
-129 -4 -68 -8 -128 -10 -135 -2 -6 -19 -13 -37 -15 -28 -3 -33 -8 -39 -36 -6
-29 -4 -35 18 -43 46 -17 116 -11 146 14 38 30 46 75 47 268 l0 156 -46 7
c-60 8 -99 8 -107 -1z"
          />
          <path
            d="M1759 553 l-66 -4 -7 -144 c-9 -178 -6 -187 67 -183 l52 3 7 104 c5
70 12 109 21 119 29 28 37 4 37 -108 0 -121 -1 -120 74 -120 l43 0 7 46 c3 26
6 74 6 108 0 49 4 64 19 73 10 7 22 9 25 6 3 -4 6 -53 6 -109 0 -118 6 -128
83 -122 l42 3 3 131 3 131 -29 31 c-35 37 -104 51 -162 32 -28 -9 -42 -9 -58
-1 -11 6 -40 10 -64 9 -24 -1 -73 -3 -109 -5z"
          />
          <path
            d="M4864 529 c-55 -27 -97 -145 -75 -212 14 -42 33 -60 91 -86 71 -33
180 -24 180 15 0 8 3 14 8 12 97 -51 170 -59 231 -28 28 14 47 32 54 51 16 41
25 36 29 -13 l3 -43 52 -9 c81 -14 83 -11 83 98 0 52 3 101 6 110 15 39 24 8
26 -91 l3 -108 59 -7 c44 -6 62 -4 68 5 4 6 8 44 8 83 0 160 28 183 32 27 l3
-108 59 -9 c49 -7 61 -6 70 7 10 13 15 13 36 1 30 -16 74 -18 101 -4 23 13 26
62 4 83 -20 21 -89 31 -114 17 -20 -10 -21 -8 -21 57 0 100 -20 134 -89 152
-41 11 -63 12 -94 4 -26 -7 -49 -8 -65 -2 -35 13 -213 3 -224 -13 -4 -7 -8
-33 -9 -58 l-1 -45 -13 30 c-18 42 -53 71 -100 84 -59 16 -137 14 -163 -5 -21
-14 -26 -14 -56 0 -38 18 -149 21 -182 5z m166 -79 c4 0 6 -30 4 -67 -3 -59
-6 -68 -26 -76 -57 -21 -90 20 -72 92 9 36 46 65 72 56 8 -3 17 -5 22 -5z
m200 -56 c0 -30 -5 -64 -11 -75 -17 -32 -39 -5 -39 48 0 50 14 83 35 83 11 0
15 -13 15 -56z"
          />
          <path
            d="M6099 533 l-67 -4 -7 -145 c-5 -93 -4 -149 3 -156 5 -5 36 -12 69
-15 l60 -5 7 103 c4 71 11 108 21 118 13 14 15 2 15 -96 l0 -112 45 -7 c25 -3
54 -4 65 -1 23 6 23 5 9 -25 -16 -36 4 -76 46 -93 53 -23 179 -20 231 6 45 21
55 37 56 90 2 47 -30 71 -109 84 -65 11 -100 35 -50 35 81 0 137 39 137 95 0
24 5 34 20 38 25 6 27 49 3 72 -11 12 -25 15 -47 10 -37 -7 -40 -7 -133 1 -71
6 -73 6 -104 -25 l-32 -32 -19 21 c-35 37 -97 49 -219 43z m401 -113 c0 -16
-4 -30 -9 -30 -12 0 -24 37 -16 50 12 20 25 10 25 -20z m-133 -77 c2 -6 -3
-13 -12 -16 -10 -5 -15 0 -15 14 0 21 21 22 27 2z m-9 -112 c3 -8 -1 -12 -9
-9 -7 2 -15 10 -17 17 -3 8 1 12 9 9 7 -2 15 -10 17 -17z m150 -29 c17 -11 5
-40 -19 -47 -24 -8 -39 1 -39 24 0 30 28 41 58 23z"
          />
          <path
            d="M4668 328 c-24 -8 -28 -15 -28 -48 0 -43 14 -59 63 -67 50 -8 77 10
77 52 0 29 -6 39 -32 55 -37 22 -41 23 -80 8z"
          />
          <path d="M2673 3 c53 -2 141 -2 195 0 53 1 9 3 -98 3 -107 0 -151 -2 -97 -3z" />
          <path d="M3728 3 c29 -2 74 -2 100 0 26 2 2 3 -53 3 -55 0 -76 -1 -47 -3z" />
          <path d="M4098 3 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
          <path
            d="M4768 3 c325 -2 859 -2 1185 0 325 1 59 2 -593 2 -652 0 -918 -1
-592 -2z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
